import React from 'react';
import { Box, Typography } from '@mui/material';

interface Props {
  title?: string;
  children: React.ReactNode;
  /** Padding applied to the body region. Charts/tables manage their own. */
  bodyPadding?: number;
}

/**
 * Bordered card wrapper shared by the structured block kinds (table, chart,
 * cost, timeline, metrics). Inherits surface + divider tokens so it reads
 * correctly in every theme.
 */
const BlockShell: React.FC<Props> = ({ title, children, bodyPadding = 1 }) => (
  <Box
    sx={{
      my: 1.5,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'divider',
      bgcolor: 'background.paper',
      overflow: 'hidden',
    }}
  >
    {title && (
      <Box
        sx={{
          px: 2,
          py: 1,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'action.hover',
        }}
      >
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </Box>
    )}
    <Box sx={{ p: bodyPadding }}>{children}</Box>
  </Box>
);

export default BlockShell;
